export default __webpack_public_path__ + "static/media/yandex.c50dc49a.svg";